<template>
    <div class="toolbox-header">
        <button class="btn-icon icon-close" @click="closeToolbox" :disabled="loading"></button>
        <h2>Hilfe</h2>
        <div class="subheader icon-arrow-down" v-show="item.parentChain.length" @click="goBack">
            {{ getLastStepTitle }}
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      closeToolbox () {
        this.$emit('close')
      },
      goBack () {
        this.item.activeEntry = this.item.parentChain.pop()
      }
    },
    computed: {
      getLastStepTitle () {
        if (this.item.parentChain.length > 0 && this.item.parentChain[this.item.parentChain.length - 1].title !== null) {
          return this.item.parentChain[this.item.parentChain.length - 1].title
        }

        return 'Themen'
      }
    }
  }
</script>

<style scoped>

</style>
